export const canDocument = () =>
  window.IS_TASK_DOCUMENTATION_SERVICE_ENABLED &&
  !document.querySelector('.execution__taskMonitor') &&
  !window.IS_FIRST_TASK &&
  !window.ENTITY_EXECUTION;
